import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/**
 * Full-screen photo preview (LinkedIn / Instagram style).
 */
const AvatarPreview = ({ open, src, alt = 'Profile photo', onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8"
      role="dialog"
      aria-modal="true"
      aria-label={alt}
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/80 backdrop-blur-sm cursor-default"
        aria-label="Close preview"
        onClick={onClose}
      />
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
        aria-label="Close"
      >
        <X className="h-5 w-5" />
      </button>
      <div className="relative z-10 max-w-[min(92vw,560px)] max-h-[85vh] animate-in fade-in zoom-in-95 duration-200">
        <img
          src={src}
          alt={alt}
          className="max-w-full max-h-[85vh] w-auto h-auto rounded-2xl object-contain shadow-2xl ring-1 ring-white/10"
          onClick={(e) => e.stopPropagation()}
        />
        {alt && (
          <p className="mt-3 text-center text-sm text-white/80 truncate px-2">{alt}</p>
        )}
      </div>
    </div>,
    document.body
  );
};

export default AvatarPreview;
